<template>
  <div class="inline-flex middle-xs tag-wrap relative mx5 my5 pointer"
       :class="{ active: isActive }"
       @click="categorySearch"
  >
    <span>{{category.name}}</span>
  </div>
</template>
<script async>
import { isServer } from '@vue-storefront/core/helpers';

export default {
  name: 'FoodCategoryLabel',
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isActive: false
    }
  },
  methods: {
    categorySearch () {
      if (isServer) {
        return
      }
      const el = document.getElementById(`category_${this.category.entity_id}`)
      return new Promise((resolve, reject) => {
        let lastHeight = el.offsetHeight
        let stableCount = 0
        const start = Date.now()

        const check = (interval = 100, timeout = 8000) => {
          const height = el.offsetHeight;

          stableCount = height === lastHeight ? stableCount + 1 : 0;
          lastHeight = height;

          if (stableCount >= 3) {
            const backToHome = document.querySelector('.back-to-home-category');
            const backToHomeOffset = (!window.pageYOffset && backToHome) ? backToHome.offsetHeight : 0;

            const top = el.getBoundingClientRect().top + window.pageYOffset - Math.abs(this.paddingWithHeaderAndMenu) - backToHomeOffset;

            window.scrollTo({ top, behavior: 'smooth' });
            return resolve();
          }

          if (Date.now() - start > timeout) {
            return reject(new Error('Timed out waiting for content to stabilize'));
          }

          setTimeout(check, interval);
        };

        check()
      })
    },
    activeCategory () {
      let el = document.getElementById('category_' + this.category.entity_id);
      if (!el) {
        return
      }
      const rect = el.getBoundingClientRect()
      const viewportMiddle = window.innerHeight / 2

      this.isActive = (
        // Top is between top and middle of viewport
        (rect.top >= this.paddingWithHeaderAndMenu && rect.top < viewportMiddle) ||

        // Element is tall and starts above viewport, but still stretches into the top half
        (rect.top < this.paddingWithHeaderAndMenu && rect.bottom > viewportMiddle)
      )
    }
  },
  computed: {
    paddingWithHeaderAndMenu () {
      let header = document.getElementById('header')
      let menu = document.getElementById('parent')
      if (header && menu) {
        return header.offsetHeight + menu.offsetHeight
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.activeCategory)
  }
}
</script>
<style lang="scss" scoped>
  .material-icons.close {
    font-size: 21px;
    position: absolute;
    right: 0;
    top: -5px;
    color: #000;
    border-radius: 50%;
    background-color: #fff;
  }
</style>
